import { ComponentType } from "react"
import { With } from "../common/componentExtensions"

import Store from "./marcheCaldaieStore"
import Actions from "./marcheCaldaieActions"

export let withMarcheCaldaie = <TProps extends {}>(cmp: ComponentType<TProps>) => With(cmp, Store, () => Actions.getAll());